const Delivery = () => {
  return (
    <svg
      width="250"
      height="203"
      viewBox="0 0 250 203"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_22278_74951)">
        <path
          d="M51.87 161.1C39.2559 150.803 19.4338 120.014 41.0579 79.2373"
          stroke="#FFE8E8"
          strokeWidth="1.43699"
          strokeLinecap="round"
        />
        <path
          d="M196.776 65.1052C211.588 81.6427 219.08 106.196 211.981 127.38C204.882 148.563 181.24 163.843 160.223 157.515C150.257 154.525 141.64 147.337 131.467 145.926C112.162 143.298 95.3467 161.5 75.824 162.141C57.1017 162.709 40.8133 145.604 37.1564 126.725C33.4994 107.847 39.947 88.1238 49.6187 71.6465C63.8635 47.3045 88.4117 26.2726 115.971 28.1905C139.111 29.582 179.552 49.0392 196.776 65.1052Z"
          fill="#FFE8E8"
        />
        <path
          d="M172.98 56.384C173.135 55.2299 173.162 54.2011 173.812 53.3178C175.114 51.4228 176.729 51.9815 178.338 52.7974C179.943 53.742 181.558 54.3007 183.46 53.4516C186.375 52.2438 187.74 47.9052 185.163 45.7759C184.302 45.109 183.399 46.114 183.501 47.0177C183.596 48.1786 184.19 49.4817 183.161 50.4833C181.747 51.8606 180.273 50.6622 178.912 49.9817C177.551 49.3011 175.925 49.1282 174.534 49.6052C172.002 50.5659 170.03 54.1159 171.975 56.4854C172.212 57.0066 172.842 56.8951 172.98 56.384Z"
          fill="#F81687"
        />
        <ellipse
          cx="127.169"
          cy="178.477"
          rx="37.4561"
          ry="6.56447"
          fill="#E8F0FF"
        />
        <path
          d="M192.508 174.316C191.696 171.496 190.882 168.542 189.939 165.723C189.671 165.053 189.144 164.788 188.492 165.199C186.277 166.835 184.061 168.337 181.848 170.109C181.457 170.382 181.595 171.188 181.991 171.454C184.498 173.18 187.931 175.706 191.079 175.811C191.866 175.803 192.379 174.587 191.589 174.19C190.27 173.395 188.826 173.139 187.378 172.614C185.799 171.956 184.218 171.163 182.767 170.235C182.772 170.773 182.775 171.177 182.649 171.717C184.996 170.214 187.209 168.442 189.555 166.804C189.161 166.673 188.636 166.678 188.241 166.547C189.185 169.366 190.259 172.183 191.333 174.866C191.73 175.266 192.645 174.988 192.508 174.316Z"
          fill="#006DFF"
        />
        <path
          d="M66.8223 145.317C64.1566 147.679 63.0779 151.542 65.4389 154.523C67.6416 157.337 72.0137 158.101 75.0003 155.91C82.1328 150.748 75.0756 140.833 67.5458 142.58C66.2367 142.869 66.5101 144.822 67.8064 145.019C69.9154 145.237 72.354 145.301 74.0991 146.968C76.0069 148.64 75.9337 151.395 74.2563 153.296C70.0586 158.212 63.2663 150.574 67.6093 146.311C68.2768 145.68 67.4898 144.686 66.8223 145.317Z"
          fill="#F81687"
        />
        <path
          d="M57.573 62.253L57.4511 62.121C56.5941 61.3255 55.3448 61.1628 54.57 62.0426C53.7951 62.9224 53.7653 64.0798 54.4936 65.0004L54.6156 65.1324C55.3473 65.9245 56.7252 65.9619 57.4967 65.2108C58.2682 64.4596 58.43 63.0484 57.573 62.253Z"
          fill="#F81687"
        />
        <path
          d="M193.509 138.007L193.387 137.875C192.53 137.079 191.28 136.917 190.506 137.797C189.731 138.676 189.701 139.834 190.429 140.754L190.551 140.886C191.283 141.678 192.661 141.716 193.432 140.965C194.204 140.214 194.366 138.802 193.509 138.007Z"
          fill="#F81687"
        />
        <circle cx="126.783" cy="45.2568" r="4.63374" fill="#006DFF" />
        <path
          d="M203.239 59.9297C209.932 67.1377 223.473 86.4965 224.091 106.267"
          stroke="#FFE8E8"
          strokeWidth="1.43699"
          strokeLinecap="round"
        />
        <path
          d="M91.8584 99.9666C91.8584 97.9058 94.0413 96.5772 95.8717 97.5239L125.546 112.872V152.597L96.7341 137.695C93.7419 136.148 91.8584 133.03 91.8584 129.625V99.9666Z"
          fill="white"
        />
        <path
          d="M121.484 80.1294C122.76 79.4696 124.153 79.1396 125.546 79.1396C126.939 79.1396 128.332 79.4696 129.608 80.1294L154.511 93.0094C156.493 94.0346 156.493 96.8694 154.511 97.8947L125.546 112.875L96.5814 97.8947C94.5992 96.8694 94.5992 94.0346 96.5814 93.0094L121.484 80.1294Z"
          fill="#E4E0FF"
        />
        <path
          d="M106.814 100.421L137.579 84.5088L146.656 89.2032L112.813 106.707V121.781L104.563 117.514V104.146C104.563 102.574 105.433 101.135 106.814 100.421Z"
          fill="#006DFF"
        />
        <path
          d="M155.22 97.5239C157.05 96.5772 159.233 97.9058 159.233 99.9666V122.764C156.937 121.69 154.374 121.09 151.671 121.09C141.799 121.09 133.796 129.093 133.796 138.965C133.796 141.744 134.43 144.374 135.561 146.72L125.546 151.9V112.872L155.22 97.5239Z"
          fill="#C0AAFE"
        />
        <path
          d="M97.2065 130.9C97.6424 130.057 98.6793 129.726 99.5226 130.162L104.913 132.948C105.756 133.384 106.086 134.421 105.65 135.264C105.214 136.107 104.178 136.437 103.334 136.002L97.9443 133.216C97.101 132.78 96.7707 131.743 97.2065 130.9Z"
          fill="#006DFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M120.492 78.3164C123.662 76.6771 127.43 76.6771 130.599 78.3164L155.349 91.1173C159.002 93.0065 161.296 96.7755 161.296 100.888V123.9C160.022 123.084 158.638 122.426 157.171 121.952V100.888C157.171 100.117 157.042 99.3656 156.8 98.6593C156.415 99.0955 155.938 99.4747 155.368 99.7694L130.599 112.58C129.646 113.073 128.638 113.418 127.608 113.615V149.651C127.983 149.533 128.35 149.383 128.704 149.199L135.172 145.854C135.708 147.136 136.389 148.342 137.194 149.452L130.599 152.863C127.43 154.502 123.662 154.502 120.492 152.863L95.7425 140.062C92.0898 138.173 89.7959 134.404 89.7959 130.292V100.888C89.7959 96.7755 92.0898 93.0065 95.7425 91.1173L120.492 78.3164ZM128.704 81.9803C126.723 80.9558 124.368 80.9558 122.388 81.9803L97.6375 94.7812L97.6183 94.7912C97.0851 95.067 97.0851 95.8296 97.6183 96.1054L122.387 108.916C124.368 109.941 126.723 109.941 128.704 108.916L153.473 96.1054C154.007 95.8296 154.007 95.0669 153.473 94.7912L153.454 94.7812L128.704 81.9803ZM93.9209 100.888C93.9209 100.117 94.0498 99.3656 94.2919 98.6594C94.6765 99.0956 95.1536 99.4747 95.7233 99.7694L120.492 112.58C121.446 113.073 122.454 113.418 123.483 113.615V149.651C123.109 149.533 122.742 149.383 122.388 149.199L97.6375 136.398C95.3546 135.218 93.9209 132.862 93.9209 130.292V100.888Z"
          fill="#006DFF"
        />
        <circle cx="151.671" cy="138.965" r="20.625" fill="#F81687" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M151.671 127.277C152.81 127.277 153.733 128.201 153.733 129.34V138.361L159.115 143.527C159.937 144.316 159.963 145.621 159.174 146.443C158.386 147.265 157.08 147.292 156.258 146.503L150.243 140.728C149.837 140.339 149.608 139.801 149.608 139.24V129.34C149.608 128.201 150.532 127.277 151.671 127.277Z"
          fill="white"
        />
        <rect
          x="52.668"
          y="107.977"
          width="27.2021"
          height="7.77202"
          rx="3.88601"
          fill="#006DFF"
        />
        <rect
          x="171.269"
          y="107.977"
          width="27.2021"
          height="7.77202"
          rx="3.88601"
          fill="#006DFF"
        />
        <circle cx="219.196" cy="111.862" r="15.544" fill="#AECCFF" />
        <path
          d="M47.2697 111.862C47.2697 120.447 40.3104 127.406 31.7257 127.406C23.1409 127.406 16.1816 120.447 16.1816 111.862C16.1816 103.278 23.1409 96.3184 31.7257 96.3184C40.3104 96.3184 47.2697 103.278 47.2697 111.862Z"
          fill="#B2E4A8"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.0711 106.61C40.6826 107.213 40.6899 108.197 40.0873 108.808L30.1905 118.852C29.8984 119.149 29.4996 119.316 29.0833 119.316C28.6671 119.316 28.2683 119.149 27.9761 118.852L23.3652 114.173C22.7626 113.561 22.7699 112.577 23.3814 111.975C23.9929 111.372 24.977 111.379 25.5796 111.991L29.0833 115.547L37.8729 106.626C38.4755 106.015 39.4596 106.008 40.0711 106.61Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_22278_74951">
          <rect
            width="250"
            height="202.073"
            fill="white"
            transform="translate(0 0.463867)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Delivery;
